<template>
  <div class="mobileCurriculum">
    <van-nav-bar
      :title="computedViewTitle"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="loading loading--error-state" v-if="this.erroring">
      <div>{{ tips }}</div>
      <van-button
        type="primary"
        block
        class="reload-exam-btn"
        :loading="reloadExamLoading"
        @click="loadExamFromServer({ userClickedReload: true })"
      >
        重新加载
      </van-button>
    </div>
    <!-- 问卷填写页面 -->
    <Questionnaire
      v-if="showQuestionnaire"
      :exam-id="questionnaireApiExamId"
      :template-code="questionnaireTemplateCode"
      @submit-success="handleQuestionnaireSubmit"
      @go-back="handleQuestionnaireGoBack"
    />

    <div class="exam-content" v-if="!this.erroring && !showQuestionnaire">
      <!-- 考试信息卡片（固定在顶部） -->
      <div class="exam-info-card">
        <div class="exam-title">{{ itemData && itemData.title }}</div>
        <div class="exam-meta">
          <div class="meta-item">
            <span class="meta-label">剩余时间</span>
            <span
              class="meta-value time-value"
              :class="{ 'time-warning': isTimeWarning }"
              >{{ timer }}</span
            >
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <span class="meta-label">当前进度</span>
            <span class="meta-value"
              >{{ examination && examination.index + 1 }}/{{
                examination && examination.total
              }}</span
            >
          </div>
        </div>
      </div>

      <!-- 题目内容区域 -->
      <div
        class="question-content"
        v-if="examination && !adjustment && examination.subject"
        :class="{ 'has-fixed-buttons': !isScrolledToBottom }"
      >
        <div class="question-card">
          <div class="question-header">
            <span class="question-type-badge">
              {{
                examination.subject.type == "SC"
                  ? "单选题"
                  : examination.subject.type == "MC"
                  ? "多选题"
                  : examination.subject.type == "TF"
                  ? "判断题"
                  : "简答题"
              }}
            </span>
            <span class="question-number"
              >第 {{ examination.index + 1 }}/{{ examination.total }} 题</span
            >
          </div>

          <div class="question-title">
            {{ examination.subject.title }}
          </div>

          <!-- 单选题：交互式卡片样式 -->
          <div
            v-if="examination.subject.type == 'SC'"
            class="options-container"
          >
            <div
              v-for="(opt, _opt) in examination.subject.options"
              :key="_opt"
              class="option-card"
              :class="{ selected: examination.value === opt.index }"
              @click="examination.value = opt.index"
            >
              <span class="option-label"
                >{{ String.fromCharCode(65 + _opt) }}.</span
              >
              <span class="option-text">{{ opt.title }}</span>
              <span
                class="option-radio"
                :class="{ checked: examination.value === opt.index }"
              ></span>
            </div>
          </div>

          <!-- 多选题：交互式卡片样式 -->
          <div
            v-if="examination.subject.type == 'MC'"
            class="options-container"
          >
            <div
              v-for="(opt, _opt) in examination.subject.options"
              :key="_opt"
              class="option-card checkbox-option"
              :class="{
                selected: (examination.value || []).includes(opt.index),
              }"
              @click="toggleMultipleChoice(opt.index)"
            >
              <span class="option-label"
                >{{ String.fromCharCode(65 + _opt) }}.</span
              >
              <span class="option-text">{{ opt.title }}</span>
              <span
                class="option-checkbox"
                :class="{
                  checked: (examination.value || []).includes(opt.index),
                }"
              ></span>
            </div>
          </div>

          <!-- 判断题：交互式卡片样式 -->
          <div
            v-if="examination.subject.type == 'TF'"
            class="options-container"
          >
            <div
              class="option-card"
              :class="{ selected: examination.value === true }"
              @click="examination.value = true"
            >
              <span class="option-label">A.</span>
              <span class="option-text">是</span>
              <span
                class="option-radio"
                :class="{ checked: examination.value === true }"
              ></span>
            </div>
            <div
              class="option-card"
              :class="{ selected: examination.value === false }"
              @click="examination.value = false"
            >
              <span class="option-label">B.</span>
              <span class="option-text">否</span>
              <span
                class="option-radio"
                :class="{ checked: examination.value === false }"
              ></span>
            </div>
          </div>

          <!-- 简答题 -->
          <div
            v-if="examination.subject.type == 'QA'"
            class="textarea-container"
          >
            <el-input
              type="textarea"
              :rows="8"
              placeholder="请在该区域内作答"
              v-model="examination.value"
              class="answer-textarea"
            >
            </el-input>
          </div>
        </div>

        <!-- 导航按钮（在内容流中的原始位置） -->
        <div v-if="isScrolledToBottom" class="nav-buttons relative-position">
          <van-button
            type="primary"
            block
            @click="submit"
            :loading="submitLoading"
            :disabled="submitLoading || !hasAnswer"
            class="nav-btn next-btn"
          >
            {{ examination.total != examination.index + 1 ? "下一题" : "提交" }}
          </van-button>
        </div>
      </div>

      <!-- 导航按钮（固定定位，悬浮在底部） -->
      <div
        v-if="
          examination &&
          !adjustment &&
          examination.subject &&
          !isScrolledToBottom
        "
        class="nav-buttons fixed-bottom"
      >
        <van-button
          type="primary"
          block
          @click="submit"
          :loading="submitLoading"
          :disabled="submitLoading || !hasAnswer"
          class="nav-btn next-btn"
        >
          {{ examination.total != examination.index + 1 ? "下一题" : "提交" }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Questionnaire from "./Questionnaire.vue";
export default {
  name: "examination",
  components: {
    Questionnaire,
  },
  data() {
    return {
      timer: "00:00",
      totalTime: 0,
      examination: null,
      itemData: null,
      erroring: false,
      countdownTimer: null,
      heartbeatTimer: null,
      heartbeatInterval: 30000,
      adjustment: false, // 是否处于调整状态
      // 问卷相关
      showQuestionnaire: false,
      questionnaireTemplateCode: null,
      viewTitle: "考试", // 默认标题
      // 滚动相关
      _isScrolledToBottom: true, // 是否滚动到底部（内部状态）
      scrollCheckTimer: null, // 滚动检测防抖定时器
      submitLoading: false,
      syncRetryCount: 0,
      reloadExamLoading: false,
      finishingExam: false,
    };
  },
  computed: {
    // 动态计算标题
    computedViewTitle() {
      // 显示考试名称（从路由参数或考试数据中获取）
      if (this.itemData && this.itemData.title) {
        return this.itemData.title;
      }
      if (this.examination && this.examination.title) {
        return this.examination.title;
      }
      return this.viewTitle || "考试";
    },
    // 是否有答案
    hasAnswer() {
      if (!this.examination || !this.examination.subject) {
        return false;
      }
      const value = this.examination.value;
      if (this.examination.subject.type === "MC") {
        return Array.isArray(value) && value.length > 0;
      }
      if (this.examination.subject.type === "QA") {
        return value && typeof value === "string" && value.trim().length > 0;
      }
      return value !== null && value !== undefined;
    },
    // 时间警告（剩余时间少于10分钟）
    isTimeWarning() {
      return this.totalTime > 0 && this.totalTime < 600; // 10分钟 = 600秒
    },
    // 是否滚动到底部
    isScrolledToBottom() {
      // 这个值会在 mounted 和 scroll 事件中更新
      return this._isScrolledToBottom !== false;
    },
    /**
     * 与 POST /api/my/exam/start/{id}、GET /api/my/exam/{id}/questionnaire 使用同一 ID：考试定义 Examination.id（路由 query.examinationId）。
     * 禁止用接口返回的 data.id（学员考试记录 StudentExamination.id），否则问卷接口必失败。
     */
    questionnaireApiExamId() {
      const raw =
        this.$route.query?.examinationId ?? this.itemData?.examinationId;
      const n = Number(raw);
      return Number.isFinite(n) && n > 0 ? n : 0;
    },
  },
  created() {
    this.itemData = this.$route.query || null;
    this.loadExamFromServer();
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener("scroll", this.handleScroll);
    // 初始检查滚动位置
    this.$nextTick(() => {
      this.checkScrollPosition();
    });
  },
  beforeUnmount() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
    // 清除定时器
    if (this.scrollCheckTimer) {
      clearTimeout(this.scrollCheckTimer);
    }
    this.stopHeartbeat();
    this.stopCountdown();
  },
  methods: {
    setTimer(initialSeconds) {
      if (typeof initialSeconds === "number") {
        this.totalTime = initialSeconds;
      }
      this.stopCountdown();
      this.updateTimerDisplay();
      this.countdownTimer = setInterval(() => {
        if (this.totalTime > 0) {
          this.totalTime--;
          this.updateTimerDisplay();
        } else {
          this.handleHeartbeatTimeout();
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    updateTimerDisplay() {
      const total = Number(this.totalTime) || 0;
      // 限制最大显示时间（避免异常值）
      const maxTime = 99 * 3600 + 59 * 60 + 59; // 99:59:59
      const clampedTotal = Math.min(Math.max(0, total), maxTime);
      const hour = parseInt(clampedTotal / 3600);
      const minute = parseInt((clampedTotal % 3600) / 60);
      const second = parseInt(clampedTotal % 60);
      const pad = (num) => String(num).padStart(2, "0");
      // 如果超过1小时，显示小时；否则只显示分钟和秒
      if (hour > 0) {
        this.timer = `${pad(hour)}:${pad(minute)}:${pad(second)}`;
      } else {
        this.timer = `${pad(minute)}:${pad(second)}`;
      }
    },
    syncLeftTime(leftTime) {
      if (typeof leftTime === "number") {
        this.totalTime = leftTime;
        this.updateTimerDisplay();
        if (leftTime <= 0) {
          this.handleHeartbeatTimeout();
        }
      }
    },
    startHeartbeat() {
      this.stopHeartbeat();
      if (!this.examination || !this.examination.id) {
        return;
      }
      this.fetchHeartbeat();
      this.heartbeatTimer = setInterval(() => {
        this.fetchHeartbeat();
      }, this.heartbeatInterval);
    },
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
    },
    fetchHeartbeat() {
      if (!this.examination || !this.examination.id) {
        return;
      }
      this.$https
        .get("/api/my/exam/heartbeat/" + this.examination.id)
        .then((res) => {
          if (res.success && res.data) {
            const data = res.data;
            this.syncLeftTime(data.leftTime);
            if (data.status && data.status !== this.examination.status) {
              this.examination.status = data.status;
            }
            if (data.status && data.status !== "processing") {
              this.handleHeartbeatTimeout();
            }
          }
        })
        .catch(() => {
          // 心跳失败忽略，保持现有倒计时
        });
    },
    handleHeartbeatTimeout() {
      if (this.isDone) {
        return;
      }
      this.stopHeartbeat();
      this.stopCountdown();
      this.isDone = true;
      this.$alert("考试时间已结束，系统将退出考试。", "提示", {
        confirmButtonText: "确定",
        center: true,
        callback: () => {
          this.onClickLeft();
        },
      });
    },
    // 切换多选题选项
    toggleMultipleChoice(optionIndex) {
      if (!this.examination || this.examination.subject.type !== "MC") {
        return;
      }
      if (!Array.isArray(this.examination.value)) {
        this.examination.value = [];
      }
      const index = this.examination.value.indexOf(optionIndex);
      if (index > -1) {
        this.examination.value.splice(index, 1);
      } else {
        this.examination.value.push(optionIndex);
      }
    },
    // 检查滚动位置
    checkScrollPosition() {
      if (this.scrollCheckTimer) {
        clearTimeout(this.scrollCheckTimer);
      }
      this.scrollCheckTimer = setTimeout(() => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const scrollBottom = scrollTop + windowHeight;
        // 判断是否滚动到底部（允许80px的误差）
        const isAtBottom = scrollBottom >= documentHeight - 80;
        this._isScrolledToBottom = isAtBottom;
      }, 200);
    },
    // 处理滚动事件
    handleScroll() {
      this.checkScrollPosition();
    },
    /**
     * 唯一入口：从后端拉取考试 / 问卷入口状态
     * @param {{ isAutoSync?: boolean }} options
     */
    async loadExamFromServer(options = {}) {
      const { isAutoSync = false, userClickedReload = false } = options;
      const examRouteId =
        this.itemData?.examinationId || this.$route.query?.examinationId;
      if (!examRouteId) {
        console.log("[H5考试] loadExamFromServer 缺少 examinationId");
        this.erroring = true;
        this.tips = "缺少考试参数，无法加载考试";
        return false;
      }

      if (userClickedReload) {
        this.reloadExamLoading = true;
      }

      try {
        console.log("[H5考试] loadExamFromServer 请求", {
          examRouteId,
          isAutoSync,
        });
        const res = await this.$https.post("/api/my/exam/start/" + examRouteId);

        if (!res.success) {
          const msg = res.message || res.debug || "加载失败";
          console.log("[H5考试] loadExamFromServer 包装层失败", { msg, res });
          if (this.isTerminalExamFinishMessage(msg)) {
            this.$toast(msg);
            await this.finishExamAndLeave();
            return false;
          }
          if (!isAutoSync) {
            this.erroring = true;
            this.tips = "错误：" + msg;
          } else {
            this.$toast.fail(msg);
          }
          return false;
        }

        const data = res.data;
        console.log("[问卷调试] loadExamFromServer 返回概要:", {
          needQuestionnaire: data.needQuestionnaire,
          questionsFinished: data.questionsFinished,
          questionnaireFinished: data.questionnaireFinished,
          hasSubject: !!data.subject,
          index: data.index,
        });

        if (
          data.needQuestionnaire &&
          data.questionsFinished &&
          !data.questionnaireFinished
        ) {
          this.erroring = false;
          console.log("[问卷调试] loadExamFromServer 进入问卷阶段");
          if (this.questionnaireApiExamId <= 0) {
            this.$toast.fail("页面缺少考试编号，请返回课程页重新进入考试");
            console.error(
              "[H5考试] 无法打开问卷：路由无 examinationId",
              this.$route.query
            );
            return false;
          }
          this.showQuestionnaire = true;
          this.questionnaireTemplateCode = data.questionnaireTemplateCode;
          this.examination = {
            id: data.id,
            ...data,
          };
          this.stopHeartbeat();
          this.stopCountdown();
          if (isAutoSync) {
            this.$toast.success("已同步，请继续填写问卷");
            console.log("[H5考试] 序号自愈后进入问卷");
          }
          return true;
        }

        if (!data.subject) {
          console.log(
            "[H5考试] loadExamFromServer 异常: 无 subject（非问卷态）"
          );
          this.showQuestionnaire = false;
          this.stopHeartbeat();
          this.stopCountdown();
          this.erroring = true;
          this.tips =
            "考试数据异常，请检查网络后点击下方「重新加载」。若多次失败请联系监考老师。";
          return false;
        }

        this.erroring = false;
        this.showQuestionnaire = false;
        this.examination = this.normalizeExamData(data);
        this.setTimer(data.leftTime);
        this.startHeartbeat();
        if (isAutoSync) {
          this.$toast.success("已同步最新题目");
          console.log("[H5考试] 序号自愈成功", {
            index: data.index,
            total: data.total,
          });
        }
        return true;
      } catch (error) {
        const msg = this.extractHttpErrorMessage(error);
        console.log("[H5考试] loadExamFromServer catch", error, msg);
        if (this.isTerminalExamFinishMessage(msg)) {
          this.$toast(msg);
          await this.finishExamAndLeave();
          return false;
        }
        if (!isAutoSync) {
          this.erroring = true;
          this.tips = "错误：" + (msg || "未知错误");
        } else {
          this.$toast.fail(msg || "网络异常，请检查网络后重试");
        }
        return false;
      } finally {
        this.reloadExamLoading = false;
      }
    },
    isTerminalExamFinishMessage(message) {
      const text = String(message || "");
      const terminalMessages = [
        "该考试已结束",
        "考试已结束",
        "问卷已完成",
        "考试次数已用完",
        "无法再次进入问卷页面",
        "考试期已结束",
      ];
      return terminalMessages.some((item) => text.includes(item));
    },
    findCurrentExamInRegistration(registration) {
      const examRouteId = String(
        this.itemData?.examinationId || this.$route.query?.examinationId || ""
      );
      if (!registration || !examRouteId) {
        return null;
      }
      const exams = Array.isArray(registration.exam)
        ? registration.exam
        : Array.isArray(registration.exams)
        ? registration.exams
        : Array.isArray(registration.examination)
        ? registration.examination
        : [];
      return (
        exams.find((item) => {
          const ids = [
            item?.examId,
            item?.examinationId,
            item?.id,
            item?.originExam?.id,
            item?.originExam?.examinationId,
          ].map((value) => String(value || ""));
          return ids.includes(examRouteId);
        }) || null
      );
    },
    async resolveExamFinishTarget() {
      const registrationId = this.$route.query?.registrationId;
      const safeFallbackTarget = {
        path: "/mobileHome",
      };
      const examListTarget = {
        path: "/courseDetail",
        query: {
          id: registrationId,
          step: "3",
        },
      };
      const certificateTarget = {
        path: "/courseDetail",
        query: {
          id: registrationId,
          step: "4",
        },
      };

      if (!registrationId) {
        localStorage.removeItem("isShowCertificate");
        return safeFallbackTarget;
      }

      localStorage.removeItem("isShowCertificate");
      try {
        const res = await this.$https.get(
          "/api/my/registration/" + registrationId
        );
        if (!res.success) {
          return examListTarget;
        }
        const currentExam = this.findCurrentExamInRegistration(res.data);
        if (currentExam?.originExam?.certPass === true) {
          localStorage.setItem("isShowCertificate", "true");
          return certificateTarget;
        }
        return examListTarget;
      } catch (error) {
        console.log("[H5考试] 刷新报名详情失败，返回考试列表", error);
        return examListTarget;
      }
    },
    async finishExamAndLeave() {
      if (this.finishingExam) {
        return;
      }
      this.finishingExam = true;
      try {
        localStorage.setItem("needRefreshCourseDetail", "true");
        this.showQuestionnaire = false;
        this.stopHeartbeat();
        this.stopCountdown();
        const target = await this.resolveExamFinishTarget();
        await this.$router.replace(target);
      } catch (error) {
        console.log("[H5考试] 完成考试后跳转失败", error);
        this.$toast.fail("返回失败，正在返回首页");
        try {
          await this.$router.replace({ path: "/mobileHome" });
        } catch (fallbackError) {
          console.log("[H5考试] 安全返回首页失败", fallbackError);
        }
      } finally {
        this.finishingExam = false;
      }
    },
    isTimeoutOrNetworkError(error) {
      if (!error) return false;
      if (error.isTimeout === true || error.isNetwork === true) return true;
      const msg = String(error.message || error.debug || "");
      const code = String(error.code || "");
      return code === "ECONNABORTED" || /timeout|network|超时|网络/i.test(msg);
    },
    extractHttpErrorMessage(error) {
      if (!error) return "网络异常，请检查网络后重试";
      const body =
        error.response?.data !== undefined
          ? error.response.data
          : error.data !== undefined
          ? error.data
          : error;
      if (typeof body === "string") return body;
      if (body && typeof body === "object") {
        return (
          body.debug ||
          body.message ||
          body.title ||
          body.error ||
          (body.message && String(body.message)) ||
          ""
        );
      }
      if (error.message && /network/i.test(String(error.message))) {
        return "网络异常，请检查网络后重试";
      }
      return error.message || "未知错误";
    },
    isSubjectIndexSyncError(text, errObj) {
      const t = (text || "").toString();
      const code = errObj && (errObj.errorCode || errObj.code);
      return (
        code === "EXAM_INDEX_MISMATCH" ||
        t.includes("提交题目序号错误") ||
        t.includes("题目索引超出范围") ||
        t.includes("状态不同步")
      );
    },
    async handleSubmitFailure(res, thrownPayload) {
      const fromRes =
        res &&
        (res.message ||
          res.debug ||
          (res.data && (res.data.message || res.data.debug)));
      const errObj =
        thrownPayload && typeof thrownPayload === "object" ? thrownPayload : {};
      const fromThrow =
        errObj.debug ||
        errObj.message ||
        errObj.title ||
        (typeof thrownPayload === "string" ? thrownPayload : "");
      const networkHint =
        thrownPayload &&
        thrownPayload.message &&
        /network|timeout|网络/i.test(String(thrownPayload.message))
          ? "网络异常，请检查网络后重试"
          : "";
      const text = [fromRes, fromThrow, networkHint].filter(Boolean).join(" ");

      if (this.isSubjectIndexSyncError(text, errObj)) {
        if (this.syncRetryCount >= 3) {
          this.$toast.fail("同步失败次数过多，请稍后再试或联系监考老师");
          console.log("[H5考试] 序号自愈达到上限，放弃", {
            syncRetryCount: this.syncRetryCount,
          });
          return;
        }
        this.syncRetryCount += 1;
        console.log("[H5考试] 序号自愈触发", {
          syncRetryCount: this.syncRetryCount,
          text,
        });
        this.$toast("检测到进度与服务器不一致，正在同步…");
        const ok = await this.loadExamFromServer({ isAutoSync: true });
        if (ok) {
          this.syncRetryCount = 0;
        }
        return;
      }

      this.$toast.fail(text || networkHint || "提交失败，请稍后重试");
    },
    async submit() {
      if (this.submitLoading) {
        return;
      }
      if (!this.hasAnswer) {
        this.$toast("请先作答！");
        return;
      }
      this.submitLoading = true;
      try {
        const res = await this.$https.post(
          "/api/my/exam/submitsubject/" + this.examination.id,
          {
            answer: this.examination.value,
            subjectIndex: this.examination.index,
          },
          { timeout: 60000 }
        );

        if (!res.success) {
          await this.handleSubmitFailure(res, null);
          return;
        }

        const data = res.data || {};
        // Jackson 可能将 Kotlin data class 的 isDone 序列化为 JSON 字段 done（与课件 isDone 处理一致）
        const subjectRoundDone = data.isDone === true || data.done === true;
        this.isDone = subjectRoundDone;

        console.log("[问卷调试] 提交题目后的返回数据:", {
          isDone: data.isDone,
          done: data.done,
          subjectRoundDone,
          needQuestionnaire: data.needQuestionnaire,
          questionnaireFinished: data.questionnaireFinished,
          questionnaireTemplateCode: data.questionnaireTemplateCode,
          questionsFinished: data.questionsFinished,
          enableQuestionnaire: data.enableQuestionnaire,
        });

        // 与 loadExamFromServer 一致：以题目完成 + 问卷未填为准，避免仅依赖 isDone 字段名差异
        if (
          data.needQuestionnaire &&
          data.questionsFinished &&
          !data.questionnaireFinished
        ) {
          console.log("[问卷调试] 进入问卷阶段");
          if (this.questionnaireApiExamId <= 0) {
            this.$toast.fail("页面缺少考试编号，请返回课程页重新进入考试");
            console.error(
              "[H5考试] 无法打开问卷：路由无 examinationId",
              this.$route.query
            );
            return;
          }
          this.erroring = false;
          this.syncRetryCount = 0;
          this.stopHeartbeat();
          this.stopCountdown();
          this.showQuestionnaire = true;
          this.questionnaireTemplateCode = data.questionnaireTemplateCode;
          this.examination = {
            ...this.examination,
            ...data,
          };
          console.log("[问卷调试] 问卷参数设置:", {
            showQuestionnaire: this.showQuestionnaire,
            questionnaireApiExamId: this.questionnaireApiExamId,
            studentExamRecordId: data.id,
            questionnaireTemplateCode: this.questionnaireTemplateCode,
          });
          return;
        }

        if (subjectRoundDone) {
          this.syncRetryCount = 0;
          this.stopHeartbeat();
          this.stopCountdown();

          if (!data.needQuestionnaire || data.questionnaireFinished) {
            if (this.shouldShowExamResult(data)) {
              this.showResultDialog(data)
                .then(() => {
                  this.finishExamAndLeave();
                })
                .catch(() => {
                  this.finishExamAndLeave();
                });
            } else {
              this.$alert("", "考试完成！", {
                confirmButtonText: "确定",
                center: true,
                callback: () => {
                  this.finishExamAndLeave();
                },
              });
            }
            return;
          }
        }

        if (!subjectRoundDone) {
          this.syncRetryCount = 0;
          this.examination = this.normalizeExamData(data);
          this.setTimer(data.leftTime);
        }
      } catch (error) {
        console.log("[H5考试] submitsubject 请求异常", error);
        if (this.isTimeoutOrNetworkError(error)) {
          this.$toast("提交请求超时，正在同步考试状态…");
          const syncOk = await this.loadExamFromServer({ isAutoSync: true });
          if (syncOk) {
            this.syncRetryCount = 0;
            return;
          }
        }
        if (error == null) {
          this.$toast.fail("网络异常，请检查网络后重试");
          return;
        }
        const errPayload =
          error && error.data !== undefined ? error.data : error;
        await this.handleSubmitFailure(null, errPayload);
      } finally {
        this.submitLoading = false;
      }
    },
    normalizeExamData(data) {
      return {
        ...data,
        value: data.subject.type == "MC" ? [] : null,
      };
    },
    showResultDialog(data) {
      const h = this.$createElement;
      let tipsTxt = "很遗憾，您没有通过此次考试";
      let tipsTxtClass = "echoErrorTitle";
      if (data.pass) {
        tipsTxt = "恭喜您通过此次考试";
        tipsTxtClass = "echoPassTitle";
      }
      const displayContentText = data.displayContent || "";
      const src = data.displayImage ? this.$domainName + data.displayImage : "";
      const contentVNode = h(
        "div",
        { class: "echoPass" },
        [
          h("div", { class: tipsTxtClass }, tipsTxt),
          displayContentText
            ? h("div", { class: "echoPassContent" }, displayContentText)
            : null,
          src
            ? h("img", {
                style: "max-width:100%;",
                attrs: { src, alt: "考试结果" },
              })
            : null,
        ].filter(Boolean)
      );
      return this.$confirm(contentVNode, "", {
        confirmButtonText: "确定",
        showCancelButton: false,
        showClose: true,
        dangerouslyUseHTMLString: false,
        center: true,
      });
    },
    shouldShowExamResult(data) {
      return !!(data && (data.needDisplay || data.displayResult));
    },
    onClickLeft() {
      // 🔥 修复：返回到课程详情页（考试列表）
      const registrationId = this.$route.query?.registrationId;
      if (registrationId) {
        // 设置需要刷新标志，确保返回时数据是最新的
        localStorage.setItem("needRefreshCourseDetail", "true");
        this.$router.replace({
          path: "/courseDetail",
          query: {
            id: registrationId,
            step: "3", // 确保显示考试步骤（步骤3）
          },
        });
      } else {
        // 如果没有 registrationId，使用默认返回
        this.$router.back();
      }
    },

    // 问卷提交成功处理
    handleQuestionnaireSubmit() {
      localStorage.setItem("needRefreshCourseDetail", "true");
      this.stopHeartbeat();
      this.stopCountdown();
      this.showQuestionnaire = false;
      console.log("[H5考试] 问卷提交成功，刷新报名详情后离开考试页");
      this.finishExamAndLeave();
    },

    /** 问卷内返回：加载失败时父级关闭问卷壳并重拉 start；其余仅提示 */
    handleQuestionnaireGoBack(payload) {
      if (payload && payload.questionnaireLoadFailed) {
        console.log("[H5考试] 问卷模板加载失败，关闭问卷壳并重新拉取 start");
        this.showQuestionnaire = false;
        this.stopHeartbeat();
        this.stopCountdown();
        this.$toast("问卷加载失败，正在刷新考试状态…");
        this.loadExamFromServer();
        return;
      }
      this.$toast("请先完成问卷，完成后即可查看考试结果");
    },
  },
};
</script>

<style lang="less" scoped>
.mobileCurriculum {
  position: relative;
  min-height: 100vh;
  width: 100%;
  background-color: #f5f5f5;

  .loading {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    line-height: 50px;
    padding: 50px 20px;

    &.loading--error-state {
      padding: 32px 20px 48px;
    }

    .reload-exam-btn {
      margin-top: 24px;
      max-width: 280px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .exam-content {
    padding-bottom: 30px;

    // 考试信息卡片（固定在顶部）
    .exam-info-card {
      position: sticky;
      top: 0;
      z-index: 100;
      background-color: #fff;
      padding: 16px;
      margin-bottom: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

      .exam-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        text-align: center;
        margin-bottom: 12px;
        line-height: 1.5;
      }

      .exam-meta {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;

        .meta-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;

          .meta-label {
            font-size: 12px;
            color: #999;
          }

          .meta-value {
            font-size: 16px;
            font-weight: 600;
            color: #333;

            &.time-value {
              color: #0095ff;

              &.time-warning {
                color: #ff4d4f;
                animation: time-warning-pulse 1s ease-in-out infinite;
              }
            }
          }
        }

        .meta-divider {
          width: 1px;
          height: 30px;
          background-color: #e8e8e8;
        }
      }
    }

    // 题目内容区域
    .question-content {
      padding: 0 16px;
      padding-bottom: 30px;

      &.has-fixed-buttons {
        padding-bottom: 100px; // 为固定按钮留出空间
      }

      .question-card {
        background-color: #fff;
        border-radius: 8px;
        padding: 20px 16px;
        margin-bottom: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

        .question-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          padding-bottom: 12px;
          border-bottom: 1px solid #f0f0f0;

          .question-type-badge {
            display: inline-block;
            padding: 4px 12px;
            background-color: #e6f7ff;
            color: #0095ff;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 500;
          }

          .question-number {
            font-size: 14px;
            color: #999;
          }
        }

        .question-title {
          font-size: 16px;
          line-height: 1.6;
          color: #333;
          margin-bottom: 20px;
          word-wrap: break-word;
          word-break: break-word;
        }

        // 选项容器
        .options-container {
          display: flex;
          flex-direction: column;
          gap: 12px;

          .option-card {
            display: flex;
            align-items: center;
            padding: 16px;
            background-color: #fafafa;
            border: 2px solid #e8e8e8;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s ease;
            min-height: 56px;

            &:active {
              transform: scale(0.98);
            }

            &.selected {
              background-color: #e6f7ff;
              border-color: #0095ff;

              .option-radio.checked,
              .option-checkbox.checked {
                background-color: #0095ff;
                border-color: #0095ff;

                &::after {
                  opacity: 1;
                }
              }
            }

            .option-label {
              font-size: 16px;
              font-weight: 600;
              color: #0095ff;
              margin-right: 12px;
              flex-shrink: 0;
            }

            .option-text {
              flex: 1;
              font-size: 16px;
              line-height: 1.5;
              color: #333;
              word-wrap: break-word;
              word-break: break-word;
            }

            .option-radio,
            .option-checkbox {
              width: 20px;
              height: 20px;
              border: 2px solid #d9d9d9;
              border-radius: 50%;
              flex-shrink: 0;
              margin-left: 12px;
              position: relative;
              transition: all 0.3s ease;

              &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 10px;
                height: 10px;
                background-color: #fff;
                border-radius: 50%;
                opacity: 0;
                transition: opacity 0.3s ease;
              }

              &.checked {
                background-color: #0095ff;
                border-color: #0095ff;

                &::after {
                  opacity: 1;
                }
              }
            }

            .option-checkbox {
              border-radius: 4px;

              &::after {
                width: 6px;
                height: 10px;
                border: 2px solid #fff;
                border-top: none;
                border-left: none;
                background-color: transparent;
                border-radius: 0;
                transform: translate(-50%, -60%) rotate(45deg);
              }
            }
          }
        }

        // 简答题容器
        .textarea-container {
          margin-top: 12px;

          .answer-textarea {
            :deep(.el-textarea__inner) {
              border-radius: 8px;
              border: 2px solid #e8e8e8;
              font-size: 16px;
              line-height: 1.6;
              padding: 12px;

              &:focus {
                border-color: #0095ff;
              }
            }
          }
        }
      }

      // 导航按钮（相对定位，在内容流中）
      .nav-buttons.relative-position {
        position: relative;
        margin-top: 20px;

        .nav-btn {
          width: 100%;
          height: 44px;
          font-size: 16px;
          border-radius: 8px;
          background-color: #0095ff;
          border: none;
        }
      }
    }

    // 导航按钮（固定定位，悬浮在底部）
    .nav-buttons.fixed-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 12px 16px;
      background-color: #fff;
      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
      z-index: 1000;

      .nav-btn {
        width: 100%;
        height: 44px;
        font-size: 16px;
        border-radius: 8px;
        background-color: #0095ff;
        border: none;
      }
    }
  }
}

// 时间警告动画
@keyframes time-warning-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

// 禁用状态
:deep(.van-button--disabled) {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
